import type { Composer } from 'vue-i18n'

const MESSAGES = {
    en: (size: string, maximum: string) => `This file is ${ size }, which is over the ${ maximum } upload limit.`,
    nl: (size: string, maximum: string) => `Dit bestand is ${ size } en daarmee groter dan de uploadlimiet van ${ maximum }.`,
}

/**
 * Checks a picked file against the server's configured limit before any of it is sent, so an oversized file fails
 * instantly instead of after a long upload. The server still enforces the limit itself.
 */
export function useUploadLimit(kind: keyof UploadLimits | ((file: File) => keyof UploadLimits)) {
    const mainStore = useMainStore()
    const { $i18n } = useNuxtApp()

    const limitFor = (file: File) => mainStore.uploadLimits[typeof kind === 'function' ? kind(file) : kind]

    /** The message to show when `file` is too large, or `null` when it may be uploaded. */
    const tooLargeMessage = (file: File): string | null => {
        const maximum = limitFor(file)
        if (!maximum || file.size <= maximum) return null
        const locale = ($i18n as Composer).locale.value === 'nl' ? 'nl' : 'en'
        return MESSAGES[locale](formatUploadBytes(file.size), formatUploadBytes(maximum))
    }

    return { limitFor, tooLargeMessage }
}
